import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'
import { useIndeedFlexCompaniesContextValue } from './IndeedFlexCompaniesProvider'

type IndeedFlexCompanyItem = ReturnType<
  typeof useIndeedFlexCompaniesContextValue
>['state']['data']['items'][number]

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

type EditCompanyWorkflow = {
  open: (company: IndeedFlexCompanyItem) => void
  close: () => void
  isOpen: boolean
  company: IndeedFlexCompanyItem | null
}

export type IndeedFlexCompaniesWorkflowsContextState = {
  createCompanyFlow: Workflow
  editCompanyFlow: EditCompanyWorkflow
}

const [
  IndeedFlexCompaniesWorkflowsContext,
  useIndeedFlexCompaniesWorkflowsContextValue,
] = createContext<IndeedFlexCompaniesWorkflowsContextState>({
  name: 'IndeedFlexCompaniesWorkflowsContext',
})

export const IndeedFlexCompaniesWorkflowsProvider = ({
  children,
}: PropsWithChildren) => {
  const [isCreateCompanyFlowOpen, setIsCreateCompanyFlowOpen] = useState(false)
  const [isEditCompanyFlowOpen, setIsEditCompanyFlowOpen] = useState(false)
  const [editCompany, setEditCompany] = useState<IndeedFlexCompanyItem | null>(
    null
  )

  const value: IndeedFlexCompaniesWorkflowsContextState = {
    createCompanyFlow: {
      open: () => setIsCreateCompanyFlowOpen(true),
      close: () => setIsCreateCompanyFlowOpen(false),
      isOpen: isCreateCompanyFlowOpen,
    },
    editCompanyFlow: {
      open: (company: IndeedFlexCompanyItem) => {
        setEditCompany(company)
        setIsEditCompanyFlowOpen(true)
      },
      close: () => setIsEditCompanyFlowOpen(false),
      isOpen: isEditCompanyFlowOpen,
      company: editCompany,
    },
  }

  return (
    <IndeedFlexCompaniesWorkflowsContext.Provider value={value}>
      {children}
    </IndeedFlexCompaniesWorkflowsContext.Provider>
  )
}

export { useIndeedFlexCompaniesWorkflowsContextValue }
